<template>
  <v-row class="fill-height">
    <v-col>
      <v-sheet height="64">
        <v-toolbar flat color="white">
          <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
            Today
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="prev">
            <v-icon small>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="next">
            <v-icon small>mdi-chevron-right</v-icon>
          </v-btn>
          <v-toolbar-title v-if="$refs.calendar">
            {{ $refs.calendar.title }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-menu bottom right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                <span>{{ typeToLabel[type] }}</span>
                <v-icon right>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="type = 'day'">
                <v-list-item-title>Day</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'week'">
                <v-list-item-title>Week</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'month'">
                <v-list-item-title>Month</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = '4day'">
                <v-list-item-title>4 days</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
      </v-sheet>
      <v-sheet height="600">
        <v-calendar
          ref="calendar"
          v-model="focus"
          color="primary"
          :events="events"
          :event-color="getEventColor"
          :type="type"
          interval-minutes="60"
          first-interval="8"
          @click:event="showEvent"
          @click:more="viewDay"
          @click:date="viewDay"
        ></v-calendar>
        <v-menu
          v-model="selectedOpen"
          :close-on-content-click="false"
          :activator="selectedElement"
          offset-x
        >
          <v-card color="grey lighten-4" min-width="350px" flat>
            <v-toolbar :color="selectedEvent.color" dark>
              <v-btn @click="selectedOpen = false" icon>
                <v-icon>mdi-close-box-multiple</v-icon>
              </v-btn>
              <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn @click="makeBooking" icon>
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn @click="popMenu" icon>
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text v-if="selectedEvent.start">
              <span v-html="'<b>From: </b>' + selectedEvent.start +'</br>' + 
                    '<b>To  : </b>' + selectedEvent.end"></span>
            </v-card-text>
            <v-card-text v-if="selectedEvent.info">
              <span v-html="'<b>Info: </b>' + selectedEvent.info"></span>
            </v-card-text>
            <v-card-text v-if="selectedEvent.location">
              <span v-html="'<b>Where: </b>' + selectedEvent.location"></span>
            </v-card-text>
            <v-card-actions>
              <!-- <v-btn text color="secondary" @click="selectedOpen = false">
                Cancel
              </v-btn> -->
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="makeBooking">
                Make Booking
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    focus: "",
    type: "month",
    typeToLabel: {
      month: "Month",
      week: "Week",
      day: "Day",
      "4day": "4 Days",
    },
    name: null,
    details: null,
    start: null,
    end: null,
    color: "#1976D2",
    currentlyEditing: null,
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],
    dialog: false,
    colors: [
      "blue",
      "indigo",
      "deep-purple",
      "cyan",
      "green",
      "orange",
      "grey darken-1",
    ],
    names: [
      "Meeting",
      "Holiday",
      "PTO",
      "Travel",
      "Event",
      "Birthday",
      "Conference",
      "Party",
    ],
    codeid: null,
  }),
  mounted() {
    this.codeid = this.$route.params.id;
    this.$refs.calendar.checkChange();
    this.getEvents();
  },
  methods: {
    popMenu() {
      alert("New Feature Coming Soon - Popup Menu");
    },
    makeBooking() {
      this.$router.push(`/AddBooking/${this.selectedEvent.id},${this.selectedEvent.name},${this.codeid}`)
      //alert("New Feature Coming Soon - Make a Booking");
    },
    getEvents() {
      // Get Events EndPoint
      let payload = {
              "Entity_id" : this.codeid
            }
      const baseURL = `https://server.ownurgoal.net.au/gen/GetEvents`;
      axios
        .post(baseURL, payload)
        .then((response) => {
          this.events = [];
          for (let i = 0; i < response.data.result.length; i++) {
            this.events.push({
              id: response.data.result[i].event_id,
              name: response.data.result[i].title,
              details: response.data.result[i].title,
              start: response.data.result[i].start_date.substr(0, 10) + ' ' + response.data.result[i].start_time.substr(0, 10),
              end: response.data.result[i].end_date.substr(0, 10) + ' ' + response.data.result[i].end_time.substr(0, 10),
              color: response.data.result[i].Color,
              location: response.data.result[i].Location,
              info: response.data.result[i].key_info,
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.error =
            "Error Retrieving Events - please check details and try again";
        });
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => (this.selectedOpen = true), 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
  },
};
</script>
